import {cardStatusVariants} from "@cdx/ds/components/DSCard/DSCardTheme.css";
import {CardId} from "../../cdx-models/Card";
import {getStatusForCard} from "../../lib/card-status-utils";
import {useInstance} from "../../lib/mate/mate-utils";
import {getParentCard} from "../workflows/workflow-utils";
import {css, cx, Row} from "@cdx/ds";

import UnMarkedown from "../../components/Markdown/UnMarkedown";
import {searchOverlayStyles} from "./search.css";

export const CardSuggestion = ({id, withinPill}: {id: CardId; withinPill?: boolean}) => {
  const card = useInstance("card", id);
  if (!card) return <div>No such Card</div>;
  const parentCard = getParentCard(card);
  const pTitle = parentCard && parentCard.$meta.get("title", null);
  const status = getStatusForCard(card);
  return (
    <Row className={cx(cardStatusVariants[status], searchOverlayStyles.cardSuggestionPill)} wrap>
      {pTitle && (
        <UnMarkedown maxChars={26} className={searchOverlayStyles.heroCardPart} onDark>
          {pTitle}
        </UnMarkedown>
      )}
      <UnMarkedown
        className={css({flexGrow: 9999, py: withinPill ? undefined : "4px", px: "8px"})}
        projectId={card.deck && card.deck.project.id}
      >
        {card.title}
      </UnMarkedown>
    </Row>
  );
};
